import { CountryIso2Code, LocaleId } from '@domgen/dgx-fe-i18n';
import {
  CustomerDetails,
  PossibleNowRequest,
  PossibleNowSource,
  RegistrationRequest,
  RegistrationSystemCode,
} from '@us-registration/util-models';
import { format } from 'date-fns';

export function getPossibleNowRequest(
  possibleNowFilterId: string,
  registrationSystemCode: RegistrationSystemCode,
  registrationRequest?: RegistrationRequest
): PossibleNowRequest | undefined {
  if (!registrationRequest) {
    return;
  }
  const formattedDate = format(new Date(), 'MM/dd/yyyy');
  const customerDetails: CustomerDetails = registrationRequest.customer;
  const brand = registrationRequest.merchandise[0].brand;

  return {
    ContactElement: {
      email: customerDetails.email as string,
    },
    customerdate: formattedDate,
    FilterID: possibleNowFilterId,
    PreferenceAttributes: [
      {
        Key: 'country',
        Value: CountryIso2Code.UnitedStates,
      },
      {
        Key: 'language',
        Value: LocaleId.English_US,
      },
      {
        Key: 'disclosureLang',
        Value: `I agree to the Terms of Use and acknowledge the privacy notice of ${brand} and Domestic and General`,
      },
      {
        Key: 'disclosurelVersion',
        Value: 'the disclosure version, if any',
      },
      {
        Key: 'consentVersion',
        Value: '2',
      },
      {
        Key: 'source',
        Value: determinePossibleNowSourceFromRegistrationSystemCode(
          registrationSystemCode
        ),
      },
      {
        Key: 'implied',
        Value: 'N',
      },
    ],
    PreferenceType: 1,
  };
}

export function determinePossibleNowSourceFromRegistrationSystemCode(
  registrationSystemCode: RegistrationSystemCode
): PossibleNowSource {
  const mapping: Record<RegistrationSystemCode, PossibleNowSource> = {
    [RegistrationSystemCode.InternetProductRegistration]: PossibleNowSource.Web,
    [RegistrationSystemCode.PhotoregProductRegistration]:
      PossibleNowSource.PhotoRegistration,
    [RegistrationSystemCode.QRCodeProductRegistration]:
      PossibleNowSource.QRCode,
  };

  return mapping[registrationSystemCode];
}
